import { Link } from "react-router-dom";
var AccountPlans = require("lib/account/AccountPlans");
var CurrentUser = require("lib/account/CurrentUser");
var LoadingButton = require("components/utility/LoadingButton");
var UpgradeHeader = require("components/users/teachers/upgrade/UpgradeHeader");
var WhooosReadingServices = require("lib/web/WhooosReadingServices")
var Glyphicon = require("components/utility/icons/Glyphicon");
var UpgradeTokenForm = require("components/users/teachers/upgrade/UpgradeTokenForm");

class PlanPreferences extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
		LuckyOrangeClient.tagComponent("PlanPreferences");
	}
	currentPlan() {
		return CurrentUser.get().account.plan_type || AccountPlans.STARTER_PLAN;
	}
	editPlanLink() {
		var plan = this.currentPlan();
		if (plan == AccountPlans.SILVER_PLAN_2019 || plan == AccountPlans.SILVER_SEMESTER_PLAN_2019) {
			return "/upgrade?plan=silver";
		} else {
			return "/upgrade?plan=gold";			
		}
	}
	hasCreditCard() {
		return CurrentUser.get().account.has_credit_card;
	}
	isPaying() {
		return CurrentUser.get().account.paying;
	}
	planClassCount() {
		return CurrentUser.get().account.plan_student_list_count;
	}
	nextChargeAmount() {
		return CurrentUser.get().account.next_charge_cents;
	}
	nextChargeTime() {
		return CurrentUser.get().account.next_charge_time;
	}
	planName(plan) {
		plan = plan || this.currentPlan();
		return AccountPlans.name(plan);
	}
	planPricingInfo() {
		return AccountPlans.pricingSummary(this.currentPlan());
	}
	toggleEditPaymentMethod(e) {
		$wr.nope(e)
		this.setState({ showPaymentMethodForm: !this.state.showPaymentMethodForm });
	}
	deleteSubscription(e) {
		$wr.nope(e)
		if (confirm("Canceling this subscription will not reverse previous charges. Are you sure you want to cancel your subscription?")) {
			var currentUser = CurrentUser.get();

			var params = { admin: { account: { has_credit_card: false } } };
			CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler((response) => {
				window.wrNotifications.triggerDropDownNotification({
					title: "Subscription Canceled", text: "You have canceled your subscription.", icon: "trash" });					
				CurrentUser.fetchCurrentUserData(() => {
					this.forceUpdate();
				});
			}));
		}
	}
	onPaymentSubmit(e) {
		$wr.nope(e)
		this.setState({ loadingPaymentUpdate: true });

		var currentUser = CurrentUser.get()
		var userData = { name: (currentUser.first_name + " " + currentUser.last_name),
			email: currentUser.email };

		this.refs.creditCard.tokenize(userData, (success, tokenData) => {
			if (success) {
				var params = {
					admin: {
						account: {
							update_card: true
						}
					},
					card_token_data: tokenData
				};
				CurrentUser.api().patchAdmin(currentUser.id, params, $wr.apiHandler((response) => {
					window.wrNotifications.triggerDropDownNotification({
						title: "Upgrade",
						text: "You have added a new payment method!",
						icon: "star"
					});
					CurrentUser.fetchCurrentUserData(() => {
						this.setState({ loadingPaymentUpdate: false, showPaymentMethodForm: false });
					});
				}));

			} else {
				this.setState({ loadingPaymentUpdate: false });
			}
		});
	}
	getRemainingTrialDays(expirationDate) {
		var now = new Date()
		var delta = Math.round((expirationDate - now) / (1000 * 3600 * 24))
		return delta + " " + (delta > 1 ? "days" : "day")
	}
	renderCurrentTrialDetails() {
		var userAccount = CurrentUser.get().account
		var currentSilverTrial = userAccount.active_trials.wrSilver != undefined;
		var currentGoldTrial = userAccount.active_trials.wrGold != undefined;

		if (currentGoldTrial) {
			if (userAccount.override_data && userAccount.override_data.wrGold && userAccount.override_data.wrGold.expiration_date) {
				var expirationDate = new Date(userAccount.override_data.wrGold.expiration_date)
			}
			
			return (
				<div className="planSection">
					<div className="planLabel">
						Current Trial:
					</div>
					Gold
					<i>  expires in {this.getRemainingTrialDays(expirationDate)}</i>
				</div>
			);
		} else if (currentSilverTrial) {
			if (userAccount.override_data && userAccount.override_data.wrSilver && userAccount.override_data.wrSilver.expiration_date) {
				var expirationDate = new Date(userAccount.override_data.wrSilver.expiration_date)
			}
			
			return (
				<div className="planSection">
					<div className="planLabel">
						Current Trial:
					</div>
					Silver
					<i>  expires in {this.getRemainingTrialDays(expirationDate)}</i>
				</div>
			);
		}

	}
	renderTrialOffer() {
		var expiredGoldTrial = CurrentUser.get().account.expired_trials.wrGold != undefined;
		var currentGoldTrial = CurrentUser.get().account.active_trials.wrGold != undefined;
		var expiredSilverTrial = CurrentUser.get().account.expired_trials.wrSilver != undefined;
		var currentSilverTrial = CurrentUser.get().account.active_trials.wrSilver != undefined;

		if (!currentSilverTrial) {

			if (!expiredSilverTrial) {
				var trialPath = "/users/" + CurrentUser.get().id + "/trigger?what=trial&features=wrSilver&days=30";
				var trialURL = WhooosReadingServices.ApiServer.url(trialPath);
				var trialLink = (<a href={ trialURL }>Start 30 day trial</a>)
				var className = "btn buttonDefault";
				
			} else {
				var className = "btn btn-link";
			}
			var benefitsList = _.map(UpgradeHeader.BENEFITS.silver, (benefitText) => {
				return (
					<div className="benefitItem" key={ benefitText }>
						<Glyphicon icon="ok" />
						<div className="benefitText">{ benefitText }</div>
					</div>
				);
			});
			return (
				<div className="upgradeBox">
					<div className="upgradeSentence">
						Upgrade to Silver
					</div>
					<div className="benefitsList">
						{ benefitsList }
					</div>
					<div className="upgradeContainer">
						<a href="/upgrade?plan=silver" className="btn buttonSuccess">
							Upgrade
						</a>
						<a href={ WhooosReadingServices.OuterPages.url("/pricing") } className={ className }>
							Learn More
						</a>
						{ trialLink }
					</div>
				</div>
			);
		}
	}

	render() {
		var currentPlan = this.currentPlan();

		var sectionClassName = "currentPlan";

		var planPaymentStatus = CurrentUser.get().account.plan_payment_status;

		if (currentPlan == AccountPlans.STARTER_PLAN && CurrentUser.get().role != "adminRole" && CurrentUser.get().account.product != "wrGold") {
			sectionClassName += " starterPlan";
			var currentPlanDetails = (
				<div className="planSection">
					<div className="planLabel">
						Current Plan:
					</div>
					{ this.planName() }
				</div>
			);

			var currentTrialDetails = this.renderCurrentTrialDetails()
			var additionalInfo = this.renderTrialOffer()

		} else if (this.isPaying()) {
			var currentPlanDetails = (
				<div className="planSection">
					<div className="planRow">
						<div className="planLabel">
							Current Plan:
						</div>
						{ this.planName() }
						<a href={ WhooosReadingServices.OuterPages.url("/pricing") }
							className="changeLink">
							Info
						</a>
					</div>
					<div className="planRow">
						<div className="planLabel">
							Plan Price:
						</div>
						{ this.planPricingInfo() }
					</div>
					<div className="planRow">
						<div className="planLabel">
							Class Count:
						</div>
						{ $wr.pluralizeWithNumber("class", this.planClassCount(), "classes") }
						<Link to={ this.editPlanLink() }
							className="changeLink">
							Add classes
						</Link>
					</div>
				</div>
			);

			if (this.hasCreditCard()) {
				var additionalInfo = (
					<div className="nextChargeDetails">
						<div className="planSection">
							<div className="planRow">
								<div className="planLabel">
									Next Charge:
								</div>
								{ $wr.formatDate(this.nextChargeTime()) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Charge Amount:
								</div>
								{ $wr.centsToDollars(this.nextChargeAmount(), true) }
								<a href="#" onClick={ this.deleteSubscription }
									className="changeLink">
									Cancel
								</a>
								<span className="cancelNote">Canceling will not reverse previous charges</span>
							</div>
							<div className="planRow">
								<div className="planLabel">
									Payment Method:
								</div>
								{ CurrentUser.paymentMethodSummary() }
								<a href="#" onClick={ this.toggleEditPaymentMethod }
									className="changeLink">
									Edit
								</a>
							</div>
						</div>
					</div>
				);

			} else if (planPaymentStatus == CREDIT_CARD_REMOVED) {
				var additionalInfo = (
					<div className="nextChargeDetails">
						<div className="planSection">
							<div className="planRow">
								<div className="planLabel">
									Cancellation Date:
								</div>
								{ $wr.formatDate(this.nextChargeTime()) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Charge Amount:
								</div>
								{ $wr.centsToDollars(this.nextChargeAmount(), true) } (will not be charged)
							</div>
							<div className="planRow">
								<div className="planLabel">
									Payment Method:
								</div>
								None
								<a href="#" onClick={ this.toggleEditPaymentMethod }
									className="changeLink">
									Add payment method
								</a>
							</div>
						</div>
					</div>
				);

			} else if (planPaymentStatus == PURCHASE_ORDER_ACTIVE) {
				var additionalInfo = (
					<div className="nextChargeDetails">
						<div className="planSection">
							<div className="planRow">
								<div className="planLabel">
									Renewal Date:
								</div>
								{ $wr.formatDate(this.nextChargeTime()) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Renewal Amount:
								</div>
								{ $wr.centsToDollars(this.nextChargeAmount(), true) }
							</div>
							<div className="planRow">
								<div className="planLabel">
									Payment Method:
								</div>
								Purchase Order
							</div>
						</div>
					</div>
				);
			}
		}

		if (CurrentUser.get().role == "adminRole" || CurrentUser.get().account.product == "wrGold") {
			var currentPlanDetails = (
				<div className="planSection">
					<div className="planRow">
						<div className="planLabel">
							Current Plan: 
						</div>
						Gold 
						<a href={ WhooosReadingServices.OuterPages.url("/pricing") }
							className="changeLink">
							Info
						</a>
					</div>
				</div>
			);
		}

		
		if (CurrentUser.isTeacherAdmin()) {
			var upgradeTokenForm = (<UpgradeTokenForm requireToggle />)
		}

		return (
			<div className={ sectionClassName + " accountCustomizer" }>
				{ currentPlanDetails }
				{ currentTrialDetails }
				{ additionalInfo }
				{ upgradeTokenForm }
			</div>
		);
	}
}


// Plan status types
var CREDIT_CARD_ACTIVE = "credit-card-active";
var CREDIT_CARD_REMOVED = "credit-card-removed";
var CREDIT_CARD_EXPIRED = "credit-card-expired";
var PURCHASE_ORDER_ACTIVE = "purchase-order-active";
var PURCHASE_ORDER_EXPIRED = "purchase-order-expired";
var STATUS_UNKNOWN = "status-unknown";

module.exports = PlanPreferences;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/preferences/PlanPreferences.js